import script from "./calendario.vue?vue&type=script&setup=true&lang=js"
export * from "./calendario.vue?vue&type=script&setup=true&lang=js"

import "./calendario.vue?vue&type=style&index=0&id=9a9ad05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a9ad05c"]])

export default __exports__